<div>
  <div class="col-lg-12 mt-3">
    <div class="row mb-3">
      <div class="col-4">
        <div class="form-group has-float-label">
          <label class="form-label">Template</label>
          <p-select
            pInputText
            [(ngModel)]="selectedTemplate"
            (onChange)="templateChange()"
            [filter]="true"
            [showClear]="true"
            [options]="templates"
            optionLabel="name">
          </p-select>
        </div>
      </div>
      <div class="col-4">
        <div class="has-float-label">
          <label class="form-label">Template Name</label>
          <input
            pInputText
            jniAutoCompleteBlocker
            name="templateName"
            type="text"
            class="form-control"
            id="templateName"
            [(ngModel)]="templateName"
            disabled />
        </div>
      </div>
      <div class="form-check p-0 col-1 d-flex gap-2 align-items-end">
        <p-checkbox
          value="size"
          name="size"
          [(ngModel)]="size"
          (change)="filterNumberAndFinishedGoods()"
          [binary]="true" />
        <label class="form-check-label" for="check1"> Size </label>
      </div>
      <div class="form-check p-0 col-1 d-flex gap-2 align-items-end">
        <p-checkbox
          value="color"
          name="color"
          [(ngModel)]="color"
          (change)="filterNumberAndFinishedGoods()"
          [binary]="true" />

        <label class="form-check-label" for="check1"> Color </label>
      </div>
      <div class="form-check p-0 col-1 d-flex gap-2 align-items-end">
        <p-checkbox
          value="fit"
          name="fit"
          [(ngModel)]="fit"
          (change)="filterNumberAndFinishedGoods()"
          [binary]="true" />

        <label class="form-check-label" for="check1"> Style / Fit </label>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <div class="has-float-label">
          <label class="form-label">Vendor Reference </label>
          <input
            pInputText
            jniAutoCompleteBlocker
            name="vendorReference"
            type="text"
            class="form-control"
            id="vendorReference"
            [(ngModel)]="vendorReference"
            (input)="setTemplateName()" />

          <span class="error-msg" *ngIf="vendorReference === '' && isSubmmited">
            Vendor Reference Field is Required
          </span>
        </div>
      </div>
      <div class="col-3 d-flex align-items-end">
        <p-button label=" Calculate Net" (click)="calculateNet()" />
      </div>
    </div>
  </div>

  <div>
    <jni-finished-goods-template-grid
      #finishedGoodsTemplateGrid
      [allReleasedProductsList]="allReleasedProductsList"
      [releasedProductsList]="releasedProductsList"
      [releasedProductsVariantsList]="releasedProductsVariantsList"
      [allReleasedProductsVariantsList]="allReleasedProductsVariantsList"
      [purchaseOrderNumber]="saleOrderIdFromModal"
      [site]="site || ''"
      [warehouse]="warehouse || ''"
      [owner]="owner || ''"
      [itemNumber]="
        header?.itemNumber || ''
      "></jni-finished-goods-template-grid>
    <jni-service-template-grid
      #servicesTemplateGrid
      (addNewServiceLine)="addNewServiceLine()"
      (editServiceLine)="editServiceLine($event)"></jni-service-template-grid>
  </div>

  <div>
    <div class="row justify-content-start pb-3">
      <div class="d-flex gap-3 justify-content-between align-items-center">
        <div class="col-auto d-flex gap-2">
          <p-button label="Create New" (click)="createTemplate()" />

          <p-button label="Overwrite Existing" (click)="overWriteTemplate()" />

          <p-button
            *ngIf="selectedTemplate"
            label=" Delete Template"
            (click)="deleteTemplateDialogBox()" />
        </div>

        <div class="col-auto d-flex gap-2">
          <p-button label="Cancel" (click)="closeModal()" />

          <p-button label="Ok" (click)="createLineGroup()" />
        </div>
      </div>
    </div>
  </div>
</div>

<jni-modal-stacker
  *ngIf="inventoryServiceLinesDisplayModal"
  [displayModal]="inventoryServiceLinesDisplayModal"
  (closeEvent)="closeModalFromInventoryServiceLines()"
  class="modal-header-sticky">
  <div class="panelBody">
    <!-- <jni-inventory-purchase-lines
      [purchaseOrderNumber]="samplePONumber"
      [fromStacker]="true"
      (closeEvent)="closeModalFromSamplePOSummary()"
    ></jni-inventory-purchase-lines> -->
    <jni-template-service-line-form
      [parent]="parent"
      [saleOrderIdFromModal]="saleOrderIdFromModal"
      [lineGroup]="lineGroup"
      [site]="site || ''"
      [warehouse]="warehouse || ''"
      [saleOrderModalStatus]="true"
      (closeEvent)="closeModalFromInventoryServiceLines()"
      (linesForTemplate)="serviceLines($event)"
      [serviceLineToEdit]="serviceLineToEdit"
      [index]="index"
      (editedServiceLine)="
        editedServiceLine($event)
      "></jni-template-service-line-form>
  </div>
</jni-modal-stacker>
<p-confirmDialog
  [appendTo]="'body'"
  header="Confirmation"
  icon="pi pi-exclamation-triangle">
  <ng-template pTemplate="footer">
    <button
      pButton
      label="Yes"
      icon="pi pi-check"
      (click)="dialogBoxButtonEvent(1)"
      class="p-button p-confirm-dialog-accept p-button-sm"></button>

    <button
      pButton
      label="No"
      icon="pi pi-times"
      (click)="dialogBoxButtonEvent(2)"
      class="p-button p-confirm-dialog-reject p-button-sm p-button-text"></button>
  </ng-template>
</p-confirmDialog>
